(function ($) {
  Drupal.behaviors.checkFacturaElectronica = {
    attach: function (context, settings) {
      let checkRespFiscal = $("input.resp_fiscal");
      let checkNoAplicaRespFiscal = $(
        '[data-drupal-selector="edit-resp-fiscal-r-99-pn"]'
      );
      let checkNoAplicaRegContable = $('input[value="ZZ"]');
      let digitalTicket = $(".form-item-digital-ticket input");

      if (checkRespFiscal[0] != null) {
        $(checkRespFiscal).each((i, check) => {
          let noAply = "R-99-PN";
          let siblingsInput = $(check).parent().siblings().children("input");

          $(check).change(() => {
            let item = $(check).val();
            if ($(check).val() == noAply) {
              $(siblingsInput).prop("checked", false);
              $(siblingsInput).removeClass("js-checked");
              $(".step-4.btn-siguiente input").removeAttr("disabled");
            }

            if ($(check).val() !== noAply) {
              $(checkNoAplicaRespFiscal).prop("checked", false);
              $(checkNoAplicaRespFiscal).removeClass("js-checked");
            }

            var hasClass = false;

            $(check).parent().siblings().each(function(i,j){
                if($(j).children().hasClass("js-checked") || $(check).hasClass("js-checked")){
                    hasClass = true;
                }
            })

            if(!hasClass){
                $(".step-4.btn-siguiente input").attr("disabled", "");
            } else {
                $(".step-4.btn-siguiente input").removeAttr("disabled");
            }
          });
        });

        $(document).ready(() => {

          if ($('.resp_fiscal input:checked').length == 0 ) {
            $(checkNoAplicaRespFiscal).prop("checked", true)
            $(checkNoAplicaRespFiscal).addClass('js-checked')
          }
  
          if ($('.form-item-regim-contable input:checked').length == 0 ) {
            $(checkNoAplicaRegContable).prop("checked", true);
            $(checkNoAplicaRegContable).parent().addClass('js-checked')

          }
        })

      }

      if (digitalTicket[0] != null) {
        let btnSiguiente = $(".step-4.btn-siguiente input");

        $(btnSiguiente).on("mousedown mouseup click", (e) => {
          $(digitalTicket)
            .parents('[id^="edit-digital-ticket"]')
            .addClass("error");
          $("#digital-ticket-error").text("Por favor seleccione una opción.");

          if (!$(".js-form-item-digital-ticket.js-checked")[0]) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
          $(digitalTicket).each((i, check) => {
            // $(check).attr('required','required');

            if (!$(check).prop("checked").length) {
            }

            $(check).on("change", () => {
              $(digitalTicket)
                .parents('[id^="edit-digital-ticket"]')
                .removeClass("error");

              if ($(check).val() == "1") {
                $(".js-form-type-email").removeClass("error-val2");
                $(".js-form-type-email").addClass("error-val1");

                if (
                  $(".js-form-type-email").val() !== "" &&
                  $(".js-form-type-email").hasClass("fixed")
                ) {
                  $(".js-form-type-email").removeClass("error-val1");
                }
              }

              if ($(check).val() == "2") {
                $(".js-form-type-email").removeClass("error-val1");
                $(".js-form-type-email").addClass("error-val2");
              }


            });
          });
        });
      }
    },
  };
})(jQuery);
